import React, { Component } from 'react';
import sermonpost from "../../../data/sermon/sermon.json";
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
}
class Sermons extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }
    render() {
        return (
            <div className="section bg-cover bg-norepeat" style={{ backgroundImage: "url(" + process.env.PUBLIC_URL + "/assets/img/church-light-sermon.jpg)" }}>
                <div className="container">
                    <div className="row align-items-center sigma_expaneded-row sigma_related-posts">
                        {/* Section Header Start */}
                        <div className="col-lg-4">
                            <div className="section-title">
                                <h6 className="subtitle text-white cursive-style">Sermons</h6>
                                <h4 className="title text-white">Watch Sermons</h4>
                                <p className="text-white">Cras ultricies ligula sed magna dictum porta. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.</p>
                            </div>
                            {/* Custom Arrows Start */}
                            <div className="sigma_arrows sigma_arrows-transparent mb-lg-30">
                                <div className="sigma_round-arrow prev-arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style={{  }} viewBox="0 0 197 197" enableBackground="new 0 0 197 197" xmlSpace="preserve">
                                        <circle className="sigma_round-arrow-stroke" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                        <circle className="sigma_round-arrow-circle" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                    </svg>
                                    <i className="far fa-chevron-left slick-arrow slider-prev" onClick={this.previous} />
                                </div>
                                <div className="sigma_round-arrow next-arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style={{  }} viewBox="0 0 197 197" enableBackground="new 0 0 197 197" xmlSpace="preserve">
                                        <circle className="sigma_round-arrow-stroke" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                        <circle className="sigma_round-arrow-circle" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                    </svg>
                                    <i className="far fa-chevron-right slick-arrow slider-next" onClick={this.next} />
                                </div>
                            </div>
                            {/* Custom Arrows End */}
                        </div>
                        {/* Section Header End */}
                        {/* Blog Post Start */}
                        <div className="px-3 w-100 position-relative">
                            <Slider ref={c => (this.slider = c)} {...settings} className="sigma_related-slider">
                                {/* Data */}
                                {sermonpost.map((item, i) => (
                                    <div key={i} className="sigma_video-popup-wrap">
                                        <img src={process.env.PUBLIC_URL + "/" + item.image} alt={item.title} />
                                        <a href={item.video} className="sigma_video-popup popup-youtube">
                                            <i className="far fa-play" />
                                        </a>
                                    </div>
                                ))}
                                {/* Data */}
                            </Slider>
                            <div className="section-button">
                                <Link to="/sermon" className="sigma_btn-custom secondary">All Sermons</Link>
                            </div>
                        </div>
                        {/* Blog Post End */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Sermons;